<div class="v4-layout-field">
  <div class="v4-layout-field-label flex flex-row items-center w-[240px]">
    <div class="channel-wrap mr-1">
      <img
        class="channel-wrap"
        [src]="(data.thirdparty_type | thirdparty)?.icon_color"
        class="w-[18px] h-[18px] rounded-full"
      />
    </div>
    <div class="title-wrap w-48 leading-tight">
      <p class="house-title" [class.active]="active" nz-paragraph [nzEllipsis]="true" [nzEllipsisRows]="2">
        {{ data.house_info?.thirdparty_house_title }}
      </p>
    </div>
    <!--    <div class="expand-icon" style="cursor: pointer" (click)="data.expand = !data.expand">-->
    <!--      <i nz-icon [nzType]="data.expand ? 'up' : 'down'" nzTheme="outline"></i>-->
    <!--    </div>-->
  </div>
  <div class="v4-layout-field-control">
    <div class="v4-layout-field-row">
      <host-radio-button
        class="radio-button"
        size="large"
        [options]="[
          { label: 'component.sidebar.status_on' | translate, value: 1 },
          { label: 'component.sidebar.status_off' | translate, value: 0 }
        ]"
        [(value)]="data.available"
      ></host-radio-button>
    </div>
  </div>
</div>

<ng-template #tooltipTpl>
  <div class="tooltip-panel" style="background-color: #fff">
    <p>最短预定天数</p>
    <p>打开后，如果订单中包含该日期，则订单的间夜数必须超过最短预定天数才允许下单。</p>
    <p>禁止当日入住</p>
    <p>打开后，该日期不允许作为订单中的第一天（入住日）。</p>
  </div>
</ng-template>
